
import { supabase } from "@/integrations/supabase/client";
import type { DocumentVersionInfo } from './documentTypes';

export const fetchDocumentVersions = async (documentId: string): Promise<DocumentVersionInfo[]> => {
  try {
    const { data, error } = await supabase
      .rpc('getdocumentversions', { documentid: documentId });

    if (error) throw error;
    return data as DocumentVersionInfo[];
  } catch (error) {
    throw error;
  }
};

export const getDownloadUrl = async (filePath: string): Promise<string> => {
  try {
    // In a real implementation, this would generate a signed URL from storage
    // For now, just return a mock URL
    return `https://example.com/download/${filePath}`;
  } catch (error) {
    throw error;
  }
};
